const products = [
  {
    id: 1,
    name: "Botanical Study Layflat Journal",
    slug: "botanical-study-layflat-journal",
    category: "Layflat Journals",
    price: "68.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-01.png",
      "/img/products/product-01-detail.png",
    ],
    description: [
      "Fine black meadow stems wander across a warm ivory cover with the quiet character of a vintage field study.",
      "Its thread-sewn binding opens flat for uninterrupted writing, planning, and sketching.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 144,
      paper: "100 gsm acid-free paper",
      binding: "Thread-sewn layflat",
      cover: "Soft-touch laminated hard cover",
    },
    tags: ["floral", "warm tones", "layflat"],
    sizes: ["Standard (5.25 × 8.25 in)", "Large (7 × 9 in)"],
    pageStyles: ["Lined", "Blank", "Dot Grid"],
    colors: ["Coral", "Marigold", "Sage"],
    artist: "Mara Velez",
    rating: 4.9,
    reviews: 128,
    isNew: true,
    bestseller: true,
  },
  {
    id: 2,
    name: "Soft Geometry Classic Notebook",
    slug: "soft-geometry-classic-notebook",
    category: "Classic Notebooks",
    price: "55.00",
    compareAtPrice: "69.00",
    images: [
      "/img/products/product-02.png",
      "/img/products/product-02-detail.png",
    ],
    description: [
      "Layered organic forms in blush, ochre, forest, and navy turn this classic notebook into a pocket-sized modernist canvas.",
      "The durable soft-touch cover and cream paper make it an easy everyday companion.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 144,
      paper: "90 gsm cream acid-free paper",
      binding: "Sewn perfect bound",
      cover: "Flexible soft-touch cover",
    },
    tags: ["botanical", "navy", "everyday"],
    sizes: ["Classic (5.25 × 8.25 in)"],
    pageStyles: ["Lined", "Blank"],
    colors: ["Midnight Navy", "Pear Green", "Ochre"],
    artist: "Theo North",
    rating: 4.8,
    reviews: 96,
    isNew: false,
    bestseller: true,
  },
  {
    id: 3,
    name: "Moonrise Lake Artist Sketchbook",
    slug: "moonrise-lake-artist-sketchbook",
    category: "Sketchbooks",
    price: "82.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-03.png",
      "/img/products/product-03-detail.png",
    ],
    description: [
      "A full moon casts a silver path across a deep alpine lake on this atmospheric, gallery-inspired sketchbook.",
      "Heavy tooth paper welcomes graphite, colored pencil, charcoal, and light ink washes.",
    ],
    attributes: {
      dimensions: "7 × 9 in",
      pages: 96,
      paper: "160 gsm bright white art paper",
      binding: "Section-sewn layflat",
      cover: "Cloth-textured hard cover",
    },
    tags: ["abstract", "blue", "art paper"],
    sizes: ["Medium (7 × 9 in)", "Square (8 × 8 in)"],
    pageStyles: ["Blank"],
    colors: ["Cobalt", "Sky", "Chalk"],
    artist: "Inez Park",
    rating: 4.9,
    reviews: 74,
    isNew: true,
    bestseller: false,
  },
  {
    id: 4,
    name: "Pocket Terrazzo Mini Notebook",
    slug: "pocket-terrazzo-mini-notebook",
    category: "Mini Notebooks",
    price: "45.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-04.png",
      "/img/products/product-04-detail.png",
    ],
    description: [
      "Soft mineral flecks scatter across a pocket notebook designed for lists, sparks, and passing thoughts.",
      "Rounded corners and a stitched spine keep it comfortable and resilient on the go.",
    ],
    attributes: {
      dimensions: "4 × 6 in",
      pages: 96,
      paper: "90 gsm recycled paper",
      binding: "Saddle stitched",
      cover: "Matte flexible cover",
    },
    tags: ["wildflower", "pocket", "recycled"],
    sizes: ["Pocket (4 × 6 in)"],
    pageStyles: ["Lined", "Dot Grid"],
    colors: ["Meadow Green", "Lavender", "Butter"],
    artist: "June Aoki",
    rating: 4.7,
    reviews: 52,
    isNew: false,
    bestseller: false,
  },
  {
    id: 5,
    name: "Citrus Picnic Layflat Journal",
    slug: "citrus-picnic-layflat-journal",
    category: "Layflat Journals",
    price: "72.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-05.png",
      "/img/products/product-05-detail.png",
    ],
    description: [
      "Painted oranges, lemons, and strawberries make this journal feel like a picnic under warm summer light.",
      "A smooth layflat construction creates a generous writing surface from edge to edge.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 160,
      paper: "100 gsm warm white paper",
      binding: "Thread-sewn layflat",
      cover: "Soft-touch laminated hard cover",
    },
    tags: ["coastal", "ocean", "calming"],
    sizes: ["Standard (5.25 × 8.25 in)", "Large (7 × 9 in)"],
    pageStyles: ["Lined", "Dot Grid"],
    colors: ["Sea Glass", "Deep Teal", "Sand"],
    artist: "Noah Bell",
    rating: 4.8,
    reviews: 111,
    isNew: true,
    bestseller: true,
  },
  {
    id: 6,
    name: "Folk Garden Classic Notebook",
    slug: "folk-garden-classic-notebook",
    category: "Classic Notebooks",
    price: "52.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-06.png",
      "/img/products/product-06-detail.png",
    ],
    description: [
      "Two bright folk birds perch among loose wildflowers on a cover made to bring color to everyday notes.",
      "Compact proportions and a flexible cover make it ideal for class, work, or morning pages.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 144,
      paper: "90 gsm cream acid-free paper",
      binding: "Sewn perfect bound",
      cover: "Velvety matte cover",
    },
    tags: ["geometric", "modern", "colorful"],
    sizes: ["Classic (5.25 × 8.25 in)"],
    pageStyles: ["Lined", "Blank", "Dot Grid"],
    colors: ["Terracotta", "Pool Blue", "Cream"],
    artist: "Paloma Reed",
    rating: 4.6,
    reviews: 67,
    isNew: false,
    bestseller: false,
  },
  {
    id: 7,
    name: "Desert Field Notes Sketchbook",
    slug: "desert-field-notes-sketchbook",
    category: "Sketchbooks",
    price: "88.00",
    compareAtPrice: "105.00",
    images: [
      "/img/products/product-07.png",
      "/img/products/product-07-detail.png",
    ],
    description: [
      "Fine cactus linework and a quiet terracotta sun bring high-desert calm to this nature-led sketchbook.",
      "Substantial paper and a layflat spine support studies made in the studio or outside.",
    ],
    attributes: {
      dimensions: "7 × 9 in",
      pages: 112,
      paper: "160 gsm natural white art paper",
      binding: "Section-sewn layflat",
      cover: "Book cloth hard cover",
    },
    tags: ["nature", "ochre", "drawing"],
    sizes: ["Medium (7 × 9 in)", "Square (8 × 8 in)"],
    pageStyles: ["Blank"],
    colors: ["Ochre", "Umber", "Flax"],
    artist: "Ellis Rowan",
    rating: 4.9,
    reviews: 83,
    isNew: false,
    bestseller: true,
  },
  {
    id: 8,
    name: "Rising Tide Mini Notebook",
    slug: "rising-tide-mini-notebook",
    category: "Mini Notebooks",
    price: "45.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-08.png",
      "/img/products/product-08-detail.png",
    ],
    description: [
      "Rolling indigo waves bring movement and focus to this pocket-sized notebook for ideas on the go.",
      "It slips easily into a bag for night thoughts, travel notes, and quick reminders.",
    ],
    attributes: {
      dimensions: "4 × 6 in",
      pages: 96,
      paper: "90 gsm recycled paper",
      binding: "Saddle stitched",
      cover: "Matte flexible cover",
    },
    tags: ["celestial", "moth", "pocket"],
    sizes: ["Pocket (4 × 6 in)"],
    pageStyles: ["Lined", "Blank"],
    colors: ["Dusky Plum", "Moon Gold", "Ink"],
    artist: "Sora Wynn",
    rating: 4.8,
    reviews: 89,
    isNew: false,
    bestseller: true,
  },
  {
    id: 9,
    name: "Meadow Morning Layflat Journal",
    slug: "meadow-morning-layflat-journal",
    category: "Layflat Journals",
    price: "68.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-09.png",
      "/img/products/product-09-detail.png",
    ],
    description: [
      "A loose meadow of poppies, daisies, and blue blooms wraps a journal built for spacious thinking.",
      "The journal opens fully flat, pairing a tactile cover with fountain-pen-friendly paper.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 144,
      paper: "100 gsm fountain-pen-friendly paper",
      binding: "Thread-sewn layflat",
      cover: "Soft-touch laminated hard cover",
    },
    tags: ["desert", "architecture", "earth tones"],
    sizes: ["Standard (5.25 × 8.25 in)", "Large (7 × 9 in)"],
    pageStyles: ["Lined", "Blank"],
    colors: ["Clay", "Sunset", "Sage"],
    artist: "Rafi Luna",
    rating: 4.7,
    reviews: 61,
    isNew: false,
    bestseller: false,
  },
  {
    id: 10,
    name: "Midnight Mushrooms Classic Notebook",
    slug: "midnight-mushrooms-classic-notebook",
    category: "Classic Notebooks",
    price: "55.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-10.png",
      "/img/products/product-10-detail.png",
    ],
    description: [
      "Rust-colored mushrooms rise beneath a small moon and scattered stars on an inky night cover.",
      "Smooth pages and a durable sewn binding are made for notes that travel everywhere.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 144,
      paper: "90 gsm cream acid-free paper",
      binding: "Sewn perfect bound",
      cover: "Flexible soft-touch cover",
    },
    tags: ["illustrated", "travel", "night"],
    sizes: ["Classic (5.25 × 8.25 in)"],
    pageStyles: ["Lined", "Dot Grid"],
    colors: ["Ink Blue", "Lantern Red", "Citrus"],
    artist: "Mei Calder",
    rating: 4.8,
    reviews: 103,
    isNew: true,
    bestseller: true,
  },
  {
    id: 11,
    name: "Sunroom Arch Artist Sketchbook",
    slug: "sunroom-arch-artist-sketchbook",
    category: "Sketchbooks",
    price: "82.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-11.png",
      "/img/products/product-11-detail.png",
    ],
    description: [
      "A blush sun balances over sculptural ochre and green forms in this quiet modernist composition.",
      "Its toothy heavyweight sheets handle dry media beautifully without excessive show-through.",
    ],
    attributes: {
      dimensions: "7 × 9 in",
      pages: 96,
      paper: "180 gsm bright white art paper",
      binding: "Section-sewn layflat",
      cover: "Cloth-textured hard cover",
    },
    tags: ["mineral", "abstract", "heavy paper"],
    sizes: ["Medium (7 × 9 in)", "Square (8 × 8 in)"],
    pageStyles: ["Blank"],
    colors: ["Lilac", "Rust", "Graphite"],
    artist: "Ada Quill",
    rating: 4.9,
    reviews: 58,
    isNew: true,
    bestseller: false,
  },
  {
    id: 12,
    name: "Lilac Check Mini Notebook",
    slug: "lilac-check-mini-notebook",
    category: "Mini Notebooks",
    price: "45.00",
    compareAtPrice: "13.00",
    images: [
      "/img/products/product-12.png",
      "/img/products/product-12-detail.png",
    ],
    description: [
      "A soft lilac checkerboard dotted with tiny flowers brightens this cheerful pocket notebook.",
      "The lightweight stitched format is sized for pockets, gift bundles, and daily lists.",
    ],
    attributes: {
      dimensions: "4 × 6 in",
      pages: 80,
      paper: "90 gsm recycled paper",
      binding: "Saddle stitched",
      cover: "Matte flexible cover",
    },
    tags: ["citrus", "bright", "giftable"],
    sizes: ["Pocket (4 × 6 in)"],
    pageStyles: ["Lined", "Dot Grid"],
    colors: ["Tangerine", "Leaf", "Blush"],
    artist: "Nico Flores",
    rating: 4.6,
    reviews: 44,
    isNew: false,
    bestseller: false,
  },
  {
    id: 13,
    name: "Radiant Day Layflat Journal",
    slug: "radiant-day-layflat-journal",
    category: "Layflat Journals",
    price: "72.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-13.png",
      "/img/products/product-13-detail.png",
    ],
    description: [
      "Hand-painted blush and ochre rays open around a bold rising sun in an optimistic study of light.",
      "Designed for long-form reflection, the sturdy journal stays open wherever inspiration lands.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 160,
      paper: "100 gsm warm white paper",
      binding: "Thread-sewn layflat",
      cover: "Soft-touch laminated hard cover",
    },
    tags: ["waves", "minimal", "reflection"],
    sizes: ["Standard (5.25 × 8.25 in)", "Large (7 × 9 in)"],
    pageStyles: ["Lined", "Dot Grid"],
    colors: ["River Blue", "Mist", "Cream"],
    artist: "Amari Stone",
    rating: 4.8,
    reviews: 77,
    isNew: false,
    bestseller: false,
  },
  {
    id: 14,
    name: "Alpine Bloom Classic Notebook",
    slug: "alpine-bloom-classic-notebook",
    category: "Classic Notebooks",
    price: "55.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-14.png",
      "/img/products/product-14-detail.png",
    ],
    description: [
      "A snow-capped peak rises beyond a blue lake and tiny alpine blooms on this transportive cover.",
      "The familiar classic format is equally at home with recipes, study notes, or plans.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 144,
      paper: "90 gsm cream acid-free paper",
      binding: "Sewn perfect bound",
      cover: "Velvety matte cover",
    },
    tags: ["still life", "food", "cheerful"],
    sizes: ["Classic (5.25 × 8.25 in)"],
    pageStyles: ["Lined", "Blank"],
    colors: ["Fig", "Cornflower", "Oat"],
    artist: "Clara Moss",
    rating: 4.7,
    reviews: 69,
    isNew: true,
    bestseller: false,
  },
  {
    id: 15,
    name: "Studio Cats Artist Sketchbook",
    slug: "studio-cats-artist-sketchbook",
    category: "Sketchbooks",
    price: "92.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-15.png",
      "/img/products/product-15-detail.png",
    ],
    description: [
      "A watchful little gathering of illustrated cats turns this artist-first sketchbook into a playful studio companion.",
      "A spacious blank interior and hard cover provide a dependable surface for visual exploration.",
    ],
    attributes: {
      dimensions: "8 × 8 in",
      pages: 112,
      paper: "160 gsm natural white art paper",
      binding: "Section-sewn layflat",
      cover: "Book cloth hard cover",
    },
    tags: ["forest", "line art", "square"],
    sizes: ["Medium (7 × 9 in)", "Square (8 × 8 in)"],
    pageStyles: ["Blank"],
    colors: ["Evergreen", "Moss", "Bone"],
    artist: "Remy Hart",
    rating: 4.8,
    reviews: 66,
    isNew: false,
    bestseller: true,
  },
  {
    id: 16,
    name: "Torn Paper Mini Notebook",
    slug: "torn-paper-mini-notebook",
    category: "Mini Notebooks",
    price: "45.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-16.png",
      "/img/products/product-16-detail.png",
    ],
    description: [
      "Torn paper shapes in mineral blue, clay, rose, and ochre turn this mini notebook into a pocket collage.",
      "Use its compact pages for observations, wishes, and ideas worth keeping close.",
    ],
    attributes: {
      dimensions: "4 × 6 in",
      pages: 96,
      paper: "90 gsm recycled paper",
      binding: "Saddle stitched",
      cover: "Matte cover with foil detail",
    },
    tags: ["stars", "celestial", "foil"],
    sizes: ["Pocket (4 × 6 in)"],
    pageStyles: ["Lined", "Blank"],
    colors: ["Ultramarine", "Silver", "Midnight"],
    artist: "Liv Anders",
    rating: 4.9,
    reviews: 117,
    isNew: false,
    bestseller: true,
  },
  {
    id: 17,
    name: "Celestial Chart Layflat Journal",
    slug: "celestial-chart-layflat-journal",
    category: "Layflat Journals",
    price: "74.00",
    compareAtPrice: "25.00",
    images: [
      "/img/products/product-17.png",
      "/img/products/product-17-detail.png",
    ],
    description: [
      "Fine golden orbits and pinprick stars trace an imagined sky chart across a deep navy journal.",
      "The layflat binding and ribbon marker make daily journaling feel naturally inviting.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 144,
      paper: "100 gsm acid-free paper",
      binding: "Thread-sewn layflat",
      cover: "Soft-touch laminated hard cover",
    },
    tags: ["kite", "playful", "color block"],
    sizes: ["Standard (5.25 × 8.25 in)", "Large (7 × 9 in)"],
    pageStyles: ["Lined", "Blank", "Dot Grid"],
    colors: ["Sky", "Poppy", "Lemon"],
    artist: "Ezra Vale",
    rating: 4.6,
    reviews: 49,
    isNew: false,
    bestseller: false,
  },
  {
    id: 18,
    name: "Threaded Meadow Classic Notebook",
    slug: "threaded-meadow-classic-notebook",
    category: "Classic Notebooks",
    price: "58.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-18.png",
      "/img/products/product-18-detail.png",
    ],
    description: [
      "Embroidered-style blooms rise across a warm linen-toned cover on this tactile, craft-inspired notebook.",
      "Its smooth, flexible cover protects pages while keeping the notebook light in hand.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 144,
      paper: "90 gsm cream acid-free paper",
      binding: "Sewn perfect bound",
      cover: "Flexible soft-touch cover",
    },
    tags: ["alpine", "floral", "green"],
    sizes: ["Classic (5.25 × 8.25 in)"],
    pageStyles: ["Lined", "Dot Grid"],
    colors: ["Pine", "Petal Pink", "Snow"],
    artist: "Freya Kim",
    rating: 4.8,
    reviews: 92,
    isNew: true,
    bestseller: true,
  },
  {
    id: 19,
    name: "Painted Studio Grid Spiral Notebook",
    slug: "studio-grid-spiral-notebook",
    category: "Spiral Notebooks",
    price: "62.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-19.png",
      "/img/products/product-19-detail.png",
    ],
    description: [
      "A precise hand-drawn grid shifts between charcoal, rust, and cream on this studio-ready spiral notebook.",
      "The sturdy twin-wire binding folds back neatly for compact desks and busy classrooms.",
    ],
    attributes: {
      dimensions: "6 × 8.5 in",
      pages: 160,
      paper: "100 gsm bright white paper",
      binding: "Bronze twin-wire spiral",
      cover: "Protective matte laminate",
    },
    tags: ["grid", "studio", "spiral"],
    sizes: ["Standard (6 × 8.5 in)", "Large (8.5 × 11 in)"],
    pageStyles: ["Lined", "Graph", "Dot Grid"],
    colors: ["Charcoal", "Rust", "Cream"],
    artist: "Dani Sol",
    rating: 4.7,
    reviews: 55,
    isNew: true,
    bestseller: false,
  },
  {
    id: 20,
    name: "Koi Garden Spiral Notebook",
    slug: "koi-garden-spiral-notebook",
    category: "Spiral Notebooks",
    price: "66.00",
    compareAtPrice: "22.00",
    images: [
      "/img/products/product-20.png",
      "/img/products/product-20-detail.png",
    ],
    description: [
      "Painted koi glide between lily pads on a deep green cover full of quiet movement.",
      "Generous pages and a fold-back spiral make room for projects, lectures, and fresh ideas.",
    ],
    attributes: {
      dimensions: "6 × 8.5 in",
      pages: 180,
      paper: "100 gsm bright white paper",
      binding: "Gold twin-wire spiral",
      cover: "Protective matte laminate",
    },
    tags: ["poppy", "painted", "spiral"],
    sizes: ["Standard (6 × 8.5 in)", "Large (8.5 × 11 in)"],
    pageStyles: ["College Ruled", "Dot Grid"],
    colors: ["Poppy Red", "Blush", "Stem Green"],
    artist: "Oona Price",
    rating: 4.9,
    reviews: 121,
    isNew: false,
    bestseller: true,
  },
  {
    id: 21,
    name: "Desert Mesa Layflat Journal",
    slug: "desert-mesa-layflat-journal",
    category: "Layflat Journals",
    price: "84.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-21.png",
      "/img/products/product-21-detail.png",
    ],
    description: [
      "Terracotta mesas and tall desert cacti sit beneath a burnished sun on this warm, expansive journal.",
      "Premium smooth paper and a true layflat spine make this journal a thoughtful writing ritual.",
    ],
    attributes: {
      dimensions: "7 × 9 in",
      pages: 176,
      paper: "110 gsm fountain-pen-friendly paper",
      binding: "Thread-sewn layflat",
      cover: "Soft-touch laminated hard cover",
    },
    tags: ["landscape", "sunset", "premium"],
    sizes: ["Standard (5.25 × 8.25 in)", "Large (7 × 9 in)"],
    pageStyles: ["Lined", "Blank"],
    colors: ["Honey", "Lavender", "Blush"],
    artist: "Miles Everly",
    rating: 4.9,
    reviews: 88,
    isNew: true,
    bestseller: true,
  },
  {
    id: 22,
    name: "Painted Canopy Classic Notebook",
    slug: "painted-canopy-classic-notebook",
    category: "Classic Notebooks",
    price: "59.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-22.png",
      "/img/products/product-22-detail.png",
    ],
    description: [
      "Layered green leaves with blush and navy accents turn this notebook into a fresh botanical study.",
      "A refined soft-touch finish and balanced cream pages suit journaling, notes, and gifting.",
    ],
    attributes: {
      dimensions: "5.25 × 8.25 in",
      pages: 144,
      paper: "90 gsm cream acid-free paper",
      binding: "Sewn perfect bound",
      cover: "Velvety matte cover",
    },
    tags: ["botanical", "blue", "gift"],
    sizes: ["Classic (5.25 × 8.25 in)"],
    pageStyles: ["Lined", "Blank", "Dot Grid"],
    colors: ["Indigo", "Eucalyptus", "Mist"],
    artist: "Samira Lane",
    rating: 4.7,
    reviews: 63,
    isNew: false,
    bestseller: false,
  },
  {
    id: 23,
    name: "Color Current Spiral Notebook",
    slug: "color-current-spiral-notebook",
    category: "Spiral Notebooks",
    price: "64.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-23.png",
      "/img/products/product-23-detail.png",
    ],
    description: [
      "Bold flowing forms in tangerine, navy, blush, and lilac give this spiral a joyful retro energy.",
      "It opens a full 360 degrees, with sturdy pages ready for everyday study and planning.",
    ],
    attributes: {
      dimensions: "6 × 8.5 in",
      pages: 160,
      paper: "100 gsm bright white paper",
      binding: "Black twin-wire spiral",
      cover: "Protective matte laminate",
    },
    tags: ["retro", "floral", "school"],
    sizes: ["Standard (6 × 8.5 in)", "Large (8.5 × 11 in)"],
    pageStyles: ["College Ruled", "Graph"],
    colors: ["Plum", "Peach", "Olive"],
    artist: "Kit Mercer",
    rating: 4.6,
    reviews: 47,
    isNew: true,
    bestseller: false,
  },
  {
    id: 24,
    name: "Golden Hour Hills Spiral Notebook",
    slug: "golden-hour-hills-spiral-notebook",
    category: "Spiral Notebooks",
    price: "69.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-24.png",
      "/img/products/product-24-detail.png",
    ],
    description: [
      "Layered sage, blush, ochre, and coral hills hold the last warm light of day on this calming spiral notebook.",
      "A resilient laminated cover and roomy spiral format keep project notes organized.",
    ],
    attributes: {
      dimensions: "8.5 × 11 in",
      pages: 180,
      paper: "100 gsm bright white paper",
      binding: "Silver twin-wire spiral",
      cover: "Protective matte laminate",
    },
    tags: ["city", "watercolor", "large format"],
    sizes: ["Standard (6 × 8.5 in)", "Large (8.5 × 11 in)"],
    pageStyles: ["College Ruled", "Dot Grid"],
    colors: ["Rain Blue", "Brick", "Slate"],
    artist: "Anya Brooks",
    rating: 4.8,
    reviews: 72,
    isNew: false,
    bestseller: false,
  },
  {
    id: 25,
    name: "Harbour Fern Layflat Journal",
    slug: "harbour-fern-layflat-journal",
    category: "Layflat Journals",
    price: "78.00",
    compareAtPrice: null,
    images: [
      "/img/products/product-25.png",
      "/img/products/product-25-detail.png",
    ],
    description: [
      "Deep teal fern fronds and warm copper details give this clothbound journal a calm, refined presence.",
      "The thread-sewn binding opens flat to warm-white pages for writing, planning, and light sketching.",
    ],
    attributes: {
      dimensions: "5.8 × 8.3 in",
      pages: 160,
      paper: "120 gsm warm-white acid-free paper",
      binding: "Thread-sewn layflat",
      cover: "Textured cloth hard cover",
    },
    tags: ["fern", "teal", "clothbound"],
    sizes: ["A5 (5.8 × 8.3 in)", "Large (7 × 9 in)"],
    pageStyles: ["Lined", "Blank", "Dot Grid"],
    colors: ["Harbour Teal", "Copper", "Fern"],
    artist: "Dartember Studio",
    rating: 4.8,
    reviews: 36,
    isNew: true,
    bestseller: false,
  },
];

const productData = products.map((product) => ({
  ...product,
  images: [product.images[0].replace(".png", "-hd.png")],
  image: product.images[0].replace(".png", "-hd.png"),
  size: product.sizes,
  material: product.attributes.paper,
  Features: [
    `${product.attributes.pages} pages`,
    product.attributes.paper,
    product.attributes.binding,
    product.attributes.cover,
  ],
}));

export { productData };
export default productData;
